import React, { useContext } from "react";
import { defineMessages } from "react-intl";
import { Typography } from "@mui/material";
import { InfoMessage } from "../alerts/InfoMessage.js";
import "../alerts/NoAccessInfoMessage.js";
import "../alerts/Message.style.js";
import { LocalizedText } from "../i18n/LocalizedText.js";
import "../alerts/InfoAlert.js";
import "../alerts/InfoMessageHoc.js";
import "./ErrorAccordion.js";
import { ErrorDetails } from "./ErrorDetails.js";
import { localized } from "./localize.js";
import "./GlobalServerErrorMessage.js";
import { LinkText } from "../link/LinkText.js";
import "../link/LinkButton.js";
import "../modal/BulkModalContent.js";
import "../modal/BulkModalProvider.js";
import "../modal/ModalButtons.js";
import "../modal/Modal.style.js";
import "../button/Buttons.js";
import "../button/EditButton.js";
import "../icons/Icon.js";
import "../icons/ExpandMoreIcon.js";
import "@opentelemetry/api";
import "../../otel/TraceProvider.js";
import "react-error-boundary";
import "rxjs/operators";
import "@opentelemetry/context-zone";
import "@opentelemetry/exporter-trace-otlp-http";
import "@opentelemetry/instrumentation";
import "@opentelemetry/instrumentation-document-load";
import "@opentelemetry/instrumentation-xml-http-request";
import "@opentelemetry/resources";
import "@opentelemetry/sdk-trace-web";
import "@opentelemetry/semantic-conventions";
import { ModalContext } from "../modal/types.js";
import "../modal/ActionConfirmationModal.js";
const localizedModal = defineMessages({
  errorModalHeader: {
    id: "errorModalHeader",
    defaultMessage: "Error"
  }
});
function ErrorModal(props) {
  const { openModal } = useContext(ModalContext);
  const handleOpenPopupClick = (content) => {
    openModal(content);
  };
  return /* @__PURE__ */ React.createElement(InfoMessage, null, /* @__PURE__ */ React.createElement(Typography, { variant: "body1" }, /* @__PURE__ */ React.createElement(LocalizedText, { label: localized.infoMessage })), /* @__PURE__ */ React.createElement(
    LinkText,
    {
      title: localized.showMoreLabel,
      onClick: () => handleOpenPopupClick({
        body: /* @__PURE__ */ React.createElement(ErrorDetails, { ...props }),
        title: /* @__PURE__ */ React.createElement(LocalizedText, { label: localizedModal.errorModalHeader })
      })
    }
  ));
}
export {
  ErrorModal
};
//# sourceMappingURL=ErrorModal.js.map
